<template>
  <v-row no-gutters class="pa-8">
    <v-col cols="12">
      <div class="text-h6">
        {{ overlay_type == "edit" ? "Edit POI Details" : "Add New POI" }}
      </div>
      <div class="primaryGrey--text" v-if="overlay_type == 'edit'">POI ID : {{ location_model.LocationID }}</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="py-6">
          <v-col cols="6">
            <v-text-field
              dense
              color="primaryDark"
              v-model="location_model.FullName"
              label="POI Name"
              :counter="100"
              :rules="maxRule(100, true)"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="location_model.LocationAddress1"
              label="POI Address"
              :counter="100"
              :rules="maxRule(100, false)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="location_model.ShortName"
              label="Short Name"
              :counter="12"
              :rules="maxRule(12, false)"
            ></v-text-field>
          </v-col>
          <v-col cols="6" v-if="page_content">
            <v-select
              dense
              color="primaryDark"
              v-model="location_model.LocationType"
              :items="page_content.LocationType"
              :rules="requiredRule"
              required
              label="POI Type"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model.number="location_model.Latitude"
              type="number"
              :rules="numberRule([-90, 90], true)"
              required
              label="Latitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model.number="location_model.Longitude"
              type="number"
              :rules="numberRule([-180, 180], true)"
              required
              label="Longitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              dense
              color="primaryDark"
              v-model="location_model.LocationCategory"
              :items="location_categories"
              label="POI Category"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              :rules="numberRule(50000, false)"
              v-model.number="location_model.Radius"
              type="number"
              label="Radius (m)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="location_model.Comment"
              label="Comments"
              :rules="maxRule(500, false)"
              :counter="500"
              append-outer-icon="mdi-comment"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn dense outlined class="mr-2 bold" @click="$emit('cancel')">Cancel</v-btn>
            <v-btn
              dense
              v-if="overlay_type == 'edit'"
              color="primary"
              @click="validate('save', location_model)"
              class="bold"
              :disabled="!valid"
              >Save</v-btn
            >
            <v-btn
              dense
              v-if="overlay_type == 'new'"
              color="primary"
              @click="validate('add', location_model)"
              class="bold"
              :disabled="!valid"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/locations.js";

export default {
  name: "EditLocationDetails",
  props: {
    location_detail: Object,
    overlay_type: String,
    location_categories: Array,
  },
  watch: {
    overlay_type: function (newVal) {
      this.valid = newVal == "edit";
    },
  },
  data: function () {
    return {
      valid: true,
      page_content: null,
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
    };
  },
  mounted() {
    this.valid = this.overlay_type == "edit";
    this.page_content = content;
  },
  methods: {
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },
    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        this.$emit(event, obj);
      }
    },
  },
  computed: {
    location_model: function () {
      let location_obj = this.location_detail ? this.location_detail : {};
      return {
        FullName: location_obj.item.FullName || "",
        LocationAddress1: location_obj.item.LocationAddress1 || "",
        ShortName: location_obj.item.ShortName || "",
        LocationType: location_obj.item.LocationType || "",
        LocationCategory: location_obj.item.LocationCategory || "",
        Latitude: location_obj.item.Latitude || "",
        LocationID: location_obj.item.LocationID || "",
        LocationImageID: location_obj.item.LocationImageID || "",
        Longitude: location_obj.item.Longitude || "",
        Radius: location_obj.item.Radius || "",
        Comment: location_obj.item.Comment || "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}
</style>
